import React from 'react'
import Select from 'antd/lib/select'
import _ from 'lodash'

function MultiIntegerInput (props) {
  const { value, onChange, disabled } = props

  const handle = (val) => {
    const sorted = _.sortBy(val.map(Number).filter(Number.isInteger)).map(String).join(',')
    onChange(sorted)
  }

  const valueArray = value
    ? value.includes(',')
      ? value.split(',')
      : [value]
    : []

  // Some magic would have to be done in order to prevent dropdown from showing due to antd version 3.x limitation that
  // enter to select does not work when no dropdown in showing. Feel free to try, but it does not seem necessary
  return <Select
    mode='tags'
    value={valueArray}
    disabled={disabled}
    onChange={handle}
    style={{ width: '100%' }}
    showArrow={false}
  />
}

export {
  MultiIntegerInput
}



// WEBPACK FOOTER //
// ./src/components/multiIntegerInput.js